import React from 'react'
import { get, pick } from 'lodash'
import CustomTable from '../../../elements/Table/CustomTable'
import MoneyCell from '../../../elements/Table/Cells/MoneyCell'
import DateTimeCell from '../../../elements/Table/Cells/DateTimeCell'
import { Link } from 'react-router-dom'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'
import { Button, Modal, Popconfirm, Row } from 'antd'
import FooterButtons from '../../../elements/Buttons/FooterButtons'
import CatalogForm from '../../../components/Common/Catalogs/CatalogForm'
import CustomSpin from '../../../elements/CustomSpin'

const CheckboxTable = checkboxHOC(CustomTable)

Catalogs.propTypes = {}

function Catalogs(props) {
  const {
    list,
    fetch,
    fetching,
    tableRef,
    selection,
    toggleSelection,
    isSelected,
    merging,
    mergeLines,
    visible,
    modalType,
    catalog,
    submitting,
    removing,
    formRef,
    onShow,
    onCancel,
    update,
    submit,
    remove,
    isNew,
    removeLine,
    removingLine,
    expanded,
    setExpanded,
  } = props
  const checkboxProps = {
    selectType: 'checkbox',
    // selectAll,
    isSelected,
    toggleSelection,
    // toggleAll,
  }
  const columns = [
    {
      Header: 'Part No',
      accessor: 'material_no',
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    {
      Header: 'MONDIALE Company',
      accessor: 'product.company.fn',
    },
    {
      Header: 'MONDIALE Stock Code',
      accessor: 'product.code',
    },
  ]
  const subColumns = [
    {
      Header: 'ID',
      accessor: '_id',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Part No',
      accessor: 'material_no',
    },
    {
      Header: 'Date',
      accessor: 'date',
      Cell: DateTimeCell,
    },
    {
      Header: 'Name',
      accessor: 'name',
    },
    {
      Header: 'Manufacturer',
      accessor: 'manufacturer',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Manufacturer Part No',
      accessor: 'manufacturer_partno',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Unit',
      accessor: 'unit',
      Cell: MoneyCell,
    },
    {
      Header: 'Currency',
      accessor: 'currency',
    },
    {
      Header: 'Rate',
      accessor: 'rate',
      Cell: MoneyCell,
    },
    {
      Header: 'Tax Rate',
      accessor: 'tax.rate',
      Cell: MoneyCell,
    },
    {
      Header: 'Link',
      accessor: '_key',
      Cell: ({ value, original }) => {
        if (get(original, 'enquiry._key')) {
          return (
            <Link
              target={'_blank'}
              to={{
                pathname: `/clients/enquiries/${original.enquiry._key}/update`,
              }}>
              {original.enquiry.code}
            </Link>
          )
        } else if (get(original, 'vendorQuote._key'))
          return (
            <Link
              target={'_blank'}
              to={{
                pathname: `/purchasing/vendor/quotes/${original.vendorQuote._key}/update`,
              }}>
              {original.vendorQuote.quoteNo}
            </Link>
          )
      },
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ value, original }) => (
        <Popconfirm
          onConfirm={() => removeLine(pick(original, ['_id', '_rev', '_key']))}
          title={"Are you suer you want to remove this line. You can't undo this ? "}>
          <a onClick={(e) => e.preventDefault()}>Remove</a>
          <CustomSpin spinning={removingLine} />
        </Popconfirm>
      ),
    },
  ]

  return (
    <>
      <Modal
        visible={visible}
        title={'Catalog'}
        onCancel={onCancel}
        destroyOnClose={true}
        footer={
          <FooterButtons
            remove={remove}
            removing={removing}
            submit={submit}
            update={update}
            submitting={submitting}
            title={'Catalog'}
            isNew={isNew}
            isEdit={!isNew}
          />
        }
        width={'75%'}>
        <Row>
          <CatalogForm ref={formRef} catalog={catalog} />
        </Row>
      </Modal>
      <CheckboxTable
        {...checkboxProps}
        CreateButton={() => (
          <Popconfirm
            placement="top"
            title={
              <span>
                Are you sure of your selections. This action will merge the two products to one and combine their lines.
                <strong> You can't undo this</strong>
              </span>
            }
            onConfirm={mergeLines}
            okText="Yes"
            cancelText="No">
            <Button loading={merging} type={'primary'} size="small" icon={'plus'} disabled={selection.length < 2}>
              Merge
            </Button>
          </Popconfirm>
        )}
        withRef={tableRef}
        columns={columns}
        data={list}
        fetch={fetch}
        fetching={fetching}
        expanded={expanded}
        onExpandedChange={setExpanded}
        SubComponent={(row) => {
          return (
            <div style={{ padding: '20px' }}>
              <CustomTable data={row.original.lines} columns={subColumns} hide={{ filter: true, refresh: true }} />
            </div>
          )
        }}
      />
    </>
  )
}

export default Catalogs
